<script setup>
import moment from "moment"
moment.locale("id")
</script>
<template>
    <DefaultLayout class="!bg-slate-50 pb-4">
        <v-row class="px-3 my-5 mx-5">
            <v-col cols="12" class="p-7 background rounded-lg">
                <h2 class="font-bold text-3xl mb-2 text-white">Selamat Datang,</h2>
                <h2 class="font-bold text-2xl text-white">
                    {{ userData.role === "kontraktor" ? kontraktor.namaKontraktor : userData.name }}
                </h2>
                <div
                    v-if="userData.role === 'kontraktor'"
                    class="flex gap-3 mt-2 items-center text-sm font-normal text-white"
                >
                    <div>
                        Klasifikasi : <span>{{ kontraktor.jenis }}</span>
                    </div>
                    <span>|</span>
                    <div>
                        <i class="mdi mdi-map-marker"></i>
                        {{ kontraktor.provinsi == "Kalimantan Selatan" ? "Lokal" : "Non Lokal" }}
                    </div>
                    <span>|</span>
                    <div>
                        Nilai Predikat :
                        <span
                            class="mdi mdi-square"
                            :class="{
                                'text-[#42b983]': kontraktor.predikat == 'HIJAU',
                                'text-[#eaaa69]': kontraktor.predikat == 'EMAS',
                                'text-[#6a91d7]': kontraktor.predikat == 'BIRU',
                                'text-[#171716]': kontraktor.predikat == 'HITAM',
                                'text-red-600': kontraktor.predikat == 'MERAH',
                            }"
                        >
                            {{ kontraktor.nilaiPredikat != null ? kontraktor.nilaiPredikat : "-" }}
                        </span>
                    </div>
                </div>

                <v-card class="my-4 p-4" v-if="userData.role === 'kontraktor'">
                    <div class="bg-white w-full rounded-lg flex justify-between items-center">
                        <div class="flex gap-2">
                            <div
                                class="w-16 h-16 rounded-lg bg-red-700 flex justify-center items-center"
                            >
                                <span class="font-bold text-3xl text-white">
                                    {{ getInitials(kontraktor.namaPjo) }}
                                </span>
                            </div>
                            <div>
                                <div class="flex items-center">
                                    <span class="text-slate-500 text-sm font-medium">
                                        Info PJO Terkait
                                    </span>
                                    <small
                                        v-if="isExpIujp"
                                        class="ml-3 text-red-700 text-sm font-medium"
                                    >
                                        ° IUJP anda akan berakhir kurang dari 6 bulan ({{
                                            moment(kontraktor.masaBerlaku).format("DD-MMM-YYYY")
                                        }})
                                    </small>
                                </div>
                                <h3 class="text-base font-bold text-black">
                                    {{ kontraktor.namaPjo }}
                                </h3>
                                <h3 class="text-sm font-medium text-black">
                                    No Surat:
                                    {{
                                        kontraktor.noPengesahanPjo != null
                                            ? kontraktor.noPengesahanPjo
                                            : "-"
                                    }}
                                </h3>
                            </div>
                        </div>
                        <div
                            class="flex gap-3 items-center cursor-pointer"
                            @click="$router.push('/profile')"
                        >
                            <span class="text-red-700 text-base font-bold font-inter underline">
                                Edit Profil
                            </span>
                            <font-awesome-icon icon="arrow-right-long" class="text-red-700" />
                        </div>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-if="userData.role === 'kontraktor'" class="mt-5 mx-4">
            <v-col cols="12" sm="8">
                <div class="w-full p-7 bg-white rounded-lg shadow-md">
                    <div class="flex gap-4">
                        <div class="w-full h-32 bg-orange-100 rounded-lg overflow-hidden">
                            <div class="w-full h-9 bg-orange-200 flex items-center">
                                <h4 class="text-base font-medium pl-4">Total Kontrak Aktif</h4>
                            </div>
                            <div class="h-24 flex items-center justify-start pl-4 w-full">
                                <h1 class="font-semibold text-5xl">
                                    {{ totalKontrakAktif }}
                                </h1>
                            </div>
                        </div>
                        <div class="w-full h-32 bg-green-100 rounded-lg overflow-hidden">
                            <div class="w-full h-9 bg-green-200 flex items-center">
                                <h4 class="text-base font-medium pl-4">Total Kontrak Selesai</h4>
                            </div>
                            <div class="h-24 flex items-center justify-start pl-4 w-full">
                                <h1 class="font-semibold text-5xl">
                                    {{ totalKontrakSelesai }}
                                </h1>
                            </div>
                        </div>
                    </div>
                    <div class="text-base font-medium text-slate-500 mt-3">
                        dari Total Kontrak {{ userData.kontraktorName }} :
                        <span class="font-bold text-slate-700">
                            {{ totalKontrak }}
                        </span>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="4">
                <div class="p-7 bg-white rounded-lg shadow-md">
                    <div class="flex justify-between items-center">
                        <h4 class="font-normal text-base text-slate-600">Ruang Lingkup Kontrak</h4>
                        <span
                            class="text-red-700 text-base font-bold font-inter cursor-pointer"
                            @click="$router.push('/kontrak')"
                        >
                            Lihat Detail
                        </span>
                    </div>
                    <v-table :class="{ 'mt-4': ruangLingkupArr3.length == 0 }">
                        <tbody>
                            <tr v-for="(item, index) in ruangLingkupArr3" :key="index">
                                <td class="w-4">
                                    <span class="text-sm text-red-900 font-semibold m-0 p-0">
                                        {{ index + 1 }}
                                    </span>
                                </td>
                                <td class="text-sm font-normal text-slate-700">
                                    {{ item }}
                                </td>
                            </tr>
                            <tr v-if="ruangLingkupArr3.length == 0">
                                <td class="text-center font-semibold">Belum Ada Data Kontrak</td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="userData.role === 'kontraktor'" class="mt-5 mx-4">
            <v-col cols="12" sm="4">
                <div class="w-full p-7 bg-white rounded-lg shadow-md">
                    <h5 class="text-base font-semibold text-slate-800">
                        Subkontraktor Inti dan Non-Inti
                    </h5>
                    <div class="flex justify-between items-center mt-5">
                        <div class="flex flex-col items-start gap-3">
                            <h5 class="text-base font-normal text-slate-600">
                                Total Subkontraktor
                            </h5>
                            <h1 class="font-bold text-3xl">
                                {{ totalSubKontraktorIntiNon }}
                            </h1>
                            <div class="flex flex-col gap-1">
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-2 bg-[#B51A1A] rounded"></div>
                                    <h5 class="text-xs font-light">
                                        {{ totalPersentasiSubKonInti }} % Inti
                                    </h5>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-2 bg-[#FF8080] rounded"></div>
                                    <h5 class="text-xs font-light">
                                        {{ totalPersentasiSubKonNonInti }} % Non Inti
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="w-48 h-auto">
                            <canvas
                                id="SubKontIntiNonInti"
                                width="90"
                                height="90"
                                class=""
                            ></canvas>
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="4">
                <div class="w-full p-7 bg-white rounded-lg shadow-md">
                    <h5 class="text-base font-semibold text-slate-800">
                        Subkontraktor Lokal dan Non-Lokal
                    </h5>
                    <div class="flex justify-between items-center mt-5">
                        <div class="flex flex-col items-start gap-3">
                            <h5 class="text-base font-normal text-slate-600">
                                Total Subkontraktor
                            </h5>
                            <h1 class="font-bold text-3xl">
                                {{ totalSubKontraktorLokalNon }}
                            </h1>
                            <div class="flex flex-col gap-1">
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-2 bg-[#FF8800] rounded"></div>
                                    <h5 class="text-xs font-light">
                                        {{ totalPersentasiSubKonLokal }} % Lokal
                                    </h5>
                                </div>
                                <div class="flex items-center gap-2">
                                    <div class="w-4 h-2 bg-[#FCCC75] rounded"></div>
                                    <h5 class="text-xs font-light">
                                        {{ totalPersentasiSubKonNonLokal }} % Non-Lokal
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div class="w-48 h-auto">
                            <canvas id="SubKonLokalSubNonLokal" width="90" height="90" />
                        </div>
                    </div>
                </div>
            </v-col>
            <v-col cols="12" sm="4">
                <div class="w-full p-7 bg-white rounded-lg shadow-md">
                    <div class="flex items-center justify-between">
                        <h5 class="text-base font-semibold text-slate-600 font-inter">
                            Status CoC :
                            <span
                                v-if="dataSio"
                                class="font-bold font-inter"
                                :class="{
                                    'text-[#FFC107]': dataSio.status == 0,
                                    'text-[#0DCAF0]': dataSio.status == 1,
                                    'text-[#DC3545]': dataSio.status == 2,
                                    'text-[#FFC107]': dataSio.status == -3,
                                    'text-[#DC3545]': dataSio.status == -4,
                                    'text-[#198754]': dataSio.status == 3,
                                    'text-[#DC3545]': dataSio.status == 5,
                                    'text-[#DC3545]': dataSio.status == 6,
                                    'text-[#DC3545]': dataSio.status == 7,
                                    'text-[#DC3545]': dataSio.status == 8,
                                }"
                            >
                                {{
                                    dataSio.status == 0
                                        ? "Draft"
                                        : dataSio.status == 1
                                        ? "On Review"
                                        : dataSio.status == 2
                                        ? "Document Complete"
                                        : dataSio.status == -3
                                        ? "Need Revision"
                                        : dataSio.status == -4
                                        ? "CoC Expired"
                                        : dataSio.status == 3
                                        ? "CoC Already Publish"
                                        : dataSio.status == 5
                                        ? "Ready to Publish"
                                        : dataSio.status == 6
                                        ? "NC Revision"
                                        : dataSio.status == 7
                                        ? "Surat Pengesahan PJO Publish"
                                        : dataSio.status == 8
                                        ? "Update Data Kontraktor"
                                        : ""
                                }}
                            </span>
                        </h5>
                        <span
                            class="text-red-700 text-base font-bold font-inter cursor-pointer"
                            @click="$router.push('/sio')"
                        >
                            Lihat Detail
                        </span>
                    </div>
                    <p class="text-gray-500 text-xs">
                        {{
                            dataSio.status == 1
                                ? "Dokumen CoC dalam proses peninjauan oleh PT Borneo Indobara"
                                : dataSio.status == 2
                                ? "Hasil presentasi calon PJO sudah memadai"
                                : dataSio.status == -3
                                ? "Dokumen CoC diperlukan revisi"
                                : dataSio.status == -4
                                ? "Masa berlaku CoC telah berakhir"
                                : dataSio.status == 3
                                ? "Dokumen CoC sudah disetujui KTT, Perusahaan dapat melakukan pekerjaan"
                                : dataSio.status == 5
                                ? "Hasil presentasi calon PJO sudah memadai"
                                : dataSio.status == 6
                                ? "Pengajuan CoC terdapat NC"
                                : dataSio.status == 7
                                ? "Dokumen Surat Pengesahan PJO sudah disetujui KTT"
                                : dataSio.status == 8
                                ? "Penerbitan CoC ditangguhkan karena butuh update data kontraktor"
                                : ""
                        }}
                    </p>
                    <div class="progress w-full mt-2">
                        <div
                            class="progress-bar bg-red-700 w-full"
                            role="progressbar"
                            :style="{
                                width:
                                    dataSio != null
                                        ? dataSio.status == 0
                                            ? '10%'
                                            : dataSio.status == 1
                                            ? '20%'
                                            : dataSio.status == -3
                                            ? '20%'
                                            : dataSio.status == 2
                                            ? '30%'
                                            : dataSio.status == 5
                                            ? '60%'
                                            : dataSio.status == 6
                                            ? '60%'
                                            : dataSio.status == 3
                                            ? '100%'
                                            : dataSio.status == 7
                                            ? '70%'
                                            : dataSio.status == 8
                                            ? '70%'
                                            : '0%'
                                        : '0%',
                            }"
                            aria-valuenow="50"
                            aria-valuemin="0"
                            aria-valuemax="100"
                        ></div>
                    </div>
                    <div class="flex justify-between items-center">
                        <h5 class="text-xs font-semibold text-gray-500">Progress</h5>
                        <span class="text-xs font-semibold text-gray-500">
                            {{
                                dataSio != null
                                    ? dataSio.status == 0
                                        ? "10%"
                                        : dataSio.status == 1
                                        ? "20%"
                                        : dataSio.status == -3
                                        ? "20%"
                                        : dataSio.status == 2
                                        ? "30%"
                                        : dataSio.status == 5
                                        ? "80%"
                                        : dataSio.status == 6
                                        ? "50%"
                                        : dataSio.status == 3
                                        ? "100%"
                                        : "0%"
                                    : "0%"
                            }}
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="userData.role !== 'kontraktor'" class="mt-5 mx-4">
            <v-col cols="12" class="mt-5 mx-2 mb-5">
                <div class="w-full p-2 bg-slate-50 rounded-lg shadow-md">
                    <div class="flex gap-4">
                        <div class="w-full h-32 bg-orange-100 rounded-lg overflow-hidden">
                            <div class="w-full h-9 bg-orange-200 flex items-center">
                                <h4 class="text-base font-medium pl-4">Total Kontrak Aktif</h4>
                            </div>
                            <div class="h-24 flex items-center justify-start pl-4 w-full">
                                <h1 class="font-semibold text-5xl">
                                    {{ totalKontrakInternalAktif }}
                                </h1>
                            </div>
                        </div>
                        <div class="w-full h-32 bg-green-100 rounded-lg overflow-hidden">
                            <div class="w-full h-9 bg-green-200 flex items-center">
                                <h4 class="text-base font-medium pl-4">Total Kontrak Selesai</h4>
                            </div>
                            <div class="h-24 flex items-center justify-start pl-4 w-full">
                                <h1 class="font-semibold text-5xl">
                                    {{ totalKontrakInternalSelesai }}
                                </h1>
                            </div>
                        </div>
                    </div>
                    <hr class="my-3 text-slate-500" />
                    <div class="text-base font-medium text-slate-400 mt-3 px-2">
                        dari Total Kontrak {{ userData.kontraktorName }} :
                        <span class="font-bold text-slate-700 text-sm">
                            {{ totalKontrakInternal }}
                        </span>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="userData.role !== 'kontraktor'" class="mx-4">
            <v-col cols="12" class="mx-2 mb-5">
                <div class="w-full p-2 bg-slate-50 rounded-lg shadow-md">
                    <v-row>
                        <v-col cols="6">
                            <div class="bg-orange-100 w-full h-auto rounded-lg p-1 shadow-sm">
                                <h2 class="font-bold text-xl text-slate-800 font-inter my-3 ml-1">
                                    Total CoC Pengesahan PJO Baru
                                </h2>
                                <div class="bg-white rounded-md w-full p-1">
                                    <div
                                        class="flex justify-between items-center p-1 rounded-t-md bg-orange-100"
                                    >
                                        <h5 class="text-sm font-semibold font-inter">
                                            Total Pengajuan
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalPengajuan }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Persyaratan Administratif
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalPersyaratanAdministratif }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Pembuatan Jadwal Presentasi
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalPembuatanJadwal }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Presentasi Calon PJO
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalPresentasi }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Pemenuhan NC Calon PJO
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalPemenuhanNc }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Proses Surat Pengesahan PJO
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalProsesSuratPengesahan }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Surat Pengesahan PJO
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalSuratPengesahan }}
                                        </h5>
                                    </div>
                                    <div
                                        class="flex justify-between items-center p-1 rounded-b-md bg-white"
                                    >
                                        <h5 class="text-sm font-semibold font-inter">
                                            CoC Approved
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardSIO.totalSioApproved }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="6">
                            <div class="bg-green-100 w-full h-auto rounded-lg p-1 shadow-sm">
                                <h2 class="font-bold text-xl text-slate-800 font-inter my-3 ml-1">
                                    Total Pengajuan IMKP
                                </h2>
                                <div class="bg-white rounded-md w-full p-1">
                                    <div
                                        class="flex justify-between items-center p-1 rounded-t-md bg-green-100"
                                    >
                                        <h5 class="text-sm font-semibold font-inter">
                                            Total Pengajuan
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalImkp }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Review Admin / OHS
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalImkpUnderReview }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Membutuhkan Revisi
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalNeedRevision }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Dokumen sudah terverifikasi
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalDocumentComplete }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Proses Penerbitan IMKP
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalProsesPenerbitanImkp }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-white">
                                        <h5 class="text-sm font-semibold font-inter">
                                            IMKP Published
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalImkpPublished }}
                                        </h5>
                                    </div>
                                    <div class="flex justify-between items-center p-1 bg-gray-100">
                                        <h5 class="text-sm font-semibold font-inter">
                                            Process BAST IMKP
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalProccessBast }}
                                        </h5>
                                    </div>
                                    <div
                                        class="flex justify-between items-center p-1 rounded-b-md bg-white"
                                    >
                                        <h5 class="text-sm font-semibold font-inter">
                                            BAST IMKP Done
                                        </h5>
                                        <h5 class="text-sm font-semibold font-inter">
                                            {{ dataDashboardImkp.totalBastDone }}
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>

        <!--Start Main Contractros Donut Chart Using For Contractors -->
        <v-row v-if="userData.role !== 'kontraktor'" class="mx-4">
            <v-col cols="12" class="mx-2 mb-5">
                <div class="bg-slate-50 w-full rounded-lg px-3 py-7 shadow-md">
                    <h2 class="text-base font-inter font-semibold text-slate-800">
                        Total Main Kontraktor : {{ totalMainKontraktor }}
                    </h2>
                    <p class="italic text-xs text-slate-600">
                        * Kontraktor yang berkontrak langsung dengan BIB
                    </p>
                    <v-row align="stretch">
                        <v-col cols="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-3 mt-3 h-full border-dotted shadow-md"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Main Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Berdasarkan Tingkat Resiko
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="bg-[rgb(181,27,27)] w-10 p-1 rounded flex justify-center items-center hover:bg-[rgb(181,20,20)] hover:ease-in"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorKritis != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorKritis"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>
                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorKritis"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorKritis"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Tingkat Resiko
                                                                    Kritis
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorKritis"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (kontraktorKritis /
                                                            totalKontraktorbyTingkatResiko) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Kritis
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FF5C5C] w-10 flex justify-center items-center hover:bg-[rgb(255,20,20)] transition ease-in duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorTinggi != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorTinggi"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>
                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorTinggi"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorTinggi"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Tingkat Resiko
                                                                    Tinggi
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorTinggi"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (kontraktorTinggi /
                                                            totalKontraktorbyTingkatResiko) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Tinggi
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#57EBA1] w-10 flex justify-center items-center hover:bg-[rgb(20,190,120)] transition ease-in duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorSedang != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorSedang"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorSedang"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorSedang"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Tingkat Resiko
                                                                    Sedang
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorSedang"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (kontraktorSedang /
                                                            totalKontraktorbyTingkatResiko) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Sedang
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FCCC75] w-10 flex justify-center items-center hover:bg-[rgb(230,180,90)] transition ease-in duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorRendah != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorRendah"
                                                    class="text-white text-[10px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorRendah"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorRendah"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Tingkat Resiko
                                                                    Rendah
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorRendah"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (kontraktorRendah /
                                                            totalKontraktorbyTingkatResiko) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Rendah
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="kontraktorTingkatResiko"
                                            width="10"
                                            height="10"
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-3 mt-3 h-full border-dotted shadow-md"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Main Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Inti & Non Inti
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="p-1 rounded bg-[#B51A1A] w-10 flex justify-center items-center hover:bg-[rgb(140,20,20)] hover:shadow-lg hover:scale-10 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorInti"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorInti"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (mainKontraktorInti /
                                                            totalMainIntiNonInti) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Inti
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FF8080] w-10 flex justify-center items-center hover:bg-[rgb(255,100,100)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorNonInti"
                                                    class="text-white text-[10px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorNonInti"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorNonInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Non Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorNonInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (mainKontraktorNonInti /
                                                            totalMainIntiNonInti) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Non Inti
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="mainKontraktorIntiNonInti"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-3 mt-3 h-full border-dotted shadow-md"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Main Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Lokal & Non Lokal
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="p-1 rounded bg-[#FCCC75] w-10 flex justify-center items-center hover:bg-[rgb(245,190,90)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorLokal.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorLokal"
                                                    class="text-white text-[10px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorLokal"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorLokal"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Lokal
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorLokal"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (mainKontraktorLokal /
                                                            totalMainLokalNonLokal) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Lokal
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FF8800] w-10 flex justify-center items-center hover:bg-[rgb(230,110,0)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorNonLokal.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainKontraktorNonLokal"
                                                    class="text-white text-[10px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainKontraktorNonLokal"
                                                tabindex="-1"
                                                aria-labelledby="mainKontraktorNonLokal"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Non Lokal
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorNonLokal"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (mainKontraktorNonLokal /
                                                            totalMainLokalNonLokal) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Non Lokal
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="mainKontraktorLokalNonLokal"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-3 mt-3 h-full border-dotted shadow-md"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Main Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Berdasarkan Kualifikasi Usaha
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="bg-[#DE9C9F] w-10 p-1 rounded border-black flex justify-center items-center hover:bg-[#e9b2b5] hover:ease-in"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorUsahaBesar != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainNamaKontraktorUsahaBesar"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>
                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainNamaKontraktorUsahaBesar"
                                                tabindex="-1"
                                                aria-labelledby="mainNamaKontraktorUsahaBesar"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Besar
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorUsahaBesar"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (mainKontraktorBesar /
                                                            (totalMainKualifikasiUsaha > 0
                                                                ? totalMainKualifikasiUsaha
                                                                : 1)) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Besar
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="bg-[rgb(247,134,134)] w-10 p-1 rounded border-black flex justify-center items-center hover:bg-[rgb(250,141,141)] hover:ease-in"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorUsahaSedang != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainNamaKontraktorUsahaSedang"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>
                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainNamaKontraktorUsahaSedang"
                                                tabindex="-1"
                                                aria-labelledby="mainNamaKontraktorUsahaSedang"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Sedang
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorUsahaSedang"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p
                                                class="text-black fw-bolder font-bold text-[11px] m-0"
                                            >
                                                {{
                                                    (
                                                        (mainKontraktorSedang /
                                                            (totalMainKualifikasiUsaha > 0
                                                                ? totalMainKualifikasiUsaha
                                                                : 1)) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Sedang
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="bg-[rgb(243,86,86)] w-10 p-1 rounded border-black flex justify-center items-center hover:bg-[rgb(243,80,80)] hover:ease-in"
                                            >
                                                <a
                                                    v-if="mainNamaKontraktorUsahaKecil != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainNamaKontraktorUsahaKecil"
                                                    class="text-white text-[11px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>
                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainNamaKontraktorUsahaKecil"
                                                tabindex="-1"
                                                aria-labelledby="mainNamaKontraktorUsahaKecil"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Main Kontraktor Kecil
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaKontraktorUsahaKecil"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p
                                                class="text-black fw-bolder font-bold text-[11px] m-0"
                                            >
                                                {{
                                                    (
                                                        (mainKontraktorKecil /
                                                            (totalMainKualifikasiUsaha > 0
                                                                ? totalMainKualifikasiUsaha
                                                                : 1)) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Kecil
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="mainKontraktorKualifikasiUsaha"
                                            width="10"
                                            height="10"
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <!--End Main Contractros Donut Chart Using For Contractors -->

        <!--Start Sub Contractros Donut Chart Using For Contractors -->
        <v-row v-if="userData.role !== 'kontraktor'" class="mx-4">
            <v-col cols="12" class="mx-2">
                <div class="bg-slate-50 w-full rounded-lg px-3 py-7 shadow-md mb-5">
                    <h2 class="text-base font-inter font-semibold text-slate-800">
                        Total Sub Kontraktor : {{ totalSubKontraktor }}
                    </h2>
                    <p class="italic text-xs text-slate-600">
                        * Kontraktor yang berkontrak langsung dengan main Kontraktor
                    </p>
                    <v-row align="stretch">
                        <v-col cols="4">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Sub Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Inti & Non Inti
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="p-1 rounded bg-[#B51A1A] w-[50px] flex justify-center items-center hover:bg-[rgb(140,20,20)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subKontraktorInti"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subKontraktorInti"
                                                tabindex="-1"
                                                aria-labelledby="subKontraktorInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorInti /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Inti
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FF8080] w-[50px] flex justify-center items-center hover:bg-[rgb(255,100,100)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subKontraktorNonInti"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subKontraktorNonInti"
                                                tabindex="-1"
                                                aria-labelledby="subKontraktorNonInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Non Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorNonInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorNonInti /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Non Inti
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="subKontraktorIntiNonInti"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <!-- Sub Main Lokal & Non Lokal -->
                        <v-col cols="4">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Sub Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Lokal & Non Lokal
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="p-1 rounded bg-[#FCCC75] w-[50px] flex justify-center items-center hover:bg-[rgb(240,190,100)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaSubKontraktorLokal.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subKontraktorLokal"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subKontraktorLokal"
                                                tabindex="-1"
                                                aria-labelledby="subKontraktorLokal"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Lokal
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorLokal"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorLokals /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Lokal
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[#FF8800] w-[50px] flex justify-center items-center hover:bg-[rgb(230,110,0)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaSubKontraktorNonLokal.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subKontraktorNonLokal"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subKontraktorNonLokal"
                                                tabindex="-1"
                                                aria-labelledby="subKontraktorNonLokal"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Non Lokal
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorNonLokal"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorNonLokal /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Non Lokal
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="subKontraktorLokalNonLokal"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="4">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Sub Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Berdasarkan Kualifikasi Usaha
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-1">
                                            <div
                                                class="p-1 rounded bg-[rgb(222,156,159)] w-[50px] flex justify-center items-center hover:bg-[rgb(200,130,135)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaSubKontraktorBesar != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subNamaKontraktorUsahaBesar"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subNamaKontraktorUsahaBesar"
                                                tabindex="-1"
                                                aria-labelledby="subNamaKontraktorUsahaBesar"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Besar
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorBesar"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorBesar /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Besar
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[rgb(246,133,133)] w-[50px] flex justify-center items-center hover:bg-[rgb(220,110,110)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaSubKontraktorSedang != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subNamaKontraktorUsahaSedang"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subNamaKontraktorUsahaSedang"
                                                tabindex="-1"
                                                aria-labelledby="subNamaKontraktorUsahaSedang"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Sedang
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorSedang"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorSedang /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Sedang
                                            </p>
                                        </div>
                                        <div class="mt-1 d-inline-flex align-items-center gap-1">
                                            <div
                                                class="p-1 rounded bg-[rgb(243,86,86)] w-[50px] flex justify-center items-center hover:bg-[rgb(220,60,60)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaSubKontraktorKecil != null"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#subNamaKontraktorUsahaKecil"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="subNamaKontraktorUsahaKecil"
                                                tabindex="-1"
                                                aria-labelledby="subNamaKontraktorUsahaKecil"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Sub Kontraktor Kecil
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaSubKontraktorKecil"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{
                                                    (
                                                        (totalSubKontraktorKecil /
                                                            totalSubKontraktor) *
                                                        100
                                                    ).toFixed(0)
                                                }}% Kecil
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="subKontraktorKualifikasiUsaha"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <!--End Sub Contractros Donut Chart Using For Contractors -->

        <!--Start Total Contractros Donut Chart Using For Contractors -->
        <v-row v-if="userData.role !== 'kontraktor'" class="mx-4">
            <v-col cols="12" class="mx-2 mb-5">
                <div class="bg-slate-50 w-full rounded-lg px-3 py-7 shadow-md mb-5">
                    <h2 class="text-base font-inter font-semibold text-slate-800">
                        Total Kontraktor : {{ totalAllKontraktor }}
                    </h2>
                    <p class="italic text-xs text-slate-600">
                        * Total Data Kontraktor dan SubKontraktor yang sudah teraggregasi jika Main
                        Kontraktor juga sebagai Subkontraktor
                    </p>
                    <v-row align="stretch">
                        <v-col cols="12" sm="6" lg="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Inti & Non Inti
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-5">
                                            <div
                                                class="p-1 rounded bg-[rgb(181,26,26)] w-[50px] flex justify-center items-center hover:bg-[rgb(140,20,20)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaAllKontraktorInti.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainAllKontraktorInti"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainAllKontraktorInti"
                                                tabindex="-1"
                                                aria-labelledby="mainAllKontraktorInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Kontraktor Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaAllKontraktorInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{ totalPersentasiKonInti }}% Inti
                                            </p>
                                        </div>
                                        <div
                                            class="mt- d-inline-flex align-items-center gap-1 mt-1"
                                        >
                                            <div
                                                class="p-1 rounded bg-[rgb(255,128,128)] w-[50px] flex justify-center items-center hover:bg-[rgb(255,100,100)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaAllKontraktorNonInti.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainAllKontraktorNonInti"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainAllKontraktorNonInti"
                                                tabindex="-1"
                                                aria-labelledby="mainAllKontraktorNonInti"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Kontraktor Non Inti
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaAllKontraktorNonInti"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{ totalPersentasiKonNonInti }}% Non Inti
                                            </p>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="KontraktorIntiNonInti"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" lg="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <h5 class="text-slate-500 text-xs mb-1">Kontraktor</h5>
                                <h4 class="text-slate-700 font-inter font-semibold text-sm">
                                    Lokal & Non-Lokal
                                </h4>
                                <div class="flex items-center justify-between overflow-hidden mt-4">
                                    <div class="flex flex-col gap-2">
                                        <div class="d-inline-flex align-items-center gap-1 mt-5">
                                            <div
                                                class="p-1 rounded bg-[rgb(252,204,117)] w-[50px] flex justify-center items-center hover:bg-[rgb(230,180,100)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                            >
                                                <a
                                                    v-if="mainNamaAllKontraktorLokal.length > 0"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#mainAllKontraktorLokal"
                                                    class="text-white text-[12px] cursor-pointer no-underline"
                                                >
                                                    Detail
                                                </a>
                                            </div>

                                            <div
                                                class="modal fade rounded-top-5"
                                                id="mainAllKontraktorLokal"
                                                tabindex="-1"
                                                aria-labelledby="mainAllKontraktorLokal"
                                                aria-hidden="true"
                                            >
                                                <div class="modal-dialog-centered rounded-top-5">
                                                    <div
                                                        class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                        style="min-height: 156px; min-width: 350px"
                                                    >
                                                        <div
                                                            class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                            style="
                                                                min-height: 100px;
                                                                min-width: 350px;
                                                                background: rgba(181, 26, 26, 1);
                                                            "
                                                        >
                                                            <div
                                                                class="d-flex justify-content-end w-100 p-2"
                                                            >
                                                                <button
                                                                    type="button"
                                                                    id="btnClose"
                                                                    class="btn"
                                                                    data-bs-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <img
                                                                        src="../../assets/icons/close_whaite.png"
                                                                        alt="icon"
                                                                        width="24"
                                                                        height="24"
                                                                    />
                                                                </button>
                                                            </div>
                                                            <div
                                                                class="p-3 text-white text-center mb-3"
                                                                style="
                                                                    font-family: Inter, sans-serif;
                                                                "
                                                            >
                                                                <h4 class="fw-bold">
                                                                    Kontraktor Lokal
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div
                                                            class="modal-body"
                                                            style="height: 50vh; overflow-y: auto"
                                                        >
                                                            <div class="p-3">
                                                                <div class="table-responsive">
                                                                    <table
                                                                        class="table mb-0"
                                                                        style="
                                                                            font-family: 'Inter-Regular',
                                                                                serif;
                                                                        "
                                                                    >
                                                                        <thead
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                        >
                                                                            <tr
                                                                                class="table-danger"
                                                                            >
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 10%;
                                                                                    "
                                                                                >
                                                                                    No.
                                                                                </th>
                                                                                <th
                                                                                    class="p-2 text-nowrap"
                                                                                    style="
                                                                                        width: 90%;
                                                                                    "
                                                                                >
                                                                                    Nama Kontraktor
                                                                                </th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody
                                                                            style="
                                                                                font-weight: 500;
                                                                                font-size: 10px;
                                                                                color: #28293d;
                                                                            "
                                                                            class="p-3"
                                                                        >
                                                                            <tr
                                                                                v-for="(
                                                                                    item, index
                                                                                ) in mainNamaAllKontraktorLokal"
                                                                                :key="index"
                                                                            >
                                                                                <td>
                                                                                    {{ index + 1 }}
                                                                                </td>
                                                                                <td>
                                                                                    {{
                                                                                        item.toString()
                                                                                    }}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <p class="text-black font-bold text-[11px] m-0">
                                                {{ totalPersentasiKontraktorLokal }}% Lokal
                                            </p>
                                        </div>
                                        <div>
                                            <div
                                                class="mt- d-inline-flex align-items-center gap-1 mt-1"
                                            >
                                                <div
                                                    class="p-1 rounded bg-[rgb(255,136,0)] w-[50px] flex justify-center items-center hover:bg-[rgb(230,120,0)] hover:shadow-md hover:scale-105 transition-transform ease-in-out duration-200"
                                                >
                                                    <a
                                                        v-if="
                                                            mainNamaAllKontraktorNonLokal.length > 0
                                                        "
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#mainAllKontraktorNonLokal"
                                                        class="text-white text-[12px] cursor-pointer no-underline"
                                                    >
                                                        Detail
                                                    </a>
                                                </div>

                                                <div
                                                    class="modal fade rounded-top-5"
                                                    id="mainAllKontraktorNonLokal"
                                                    tabindex="-1"
                                                    aria-labelledby="mainAllKontraktorNonLokal"
                                                    aria-hidden="true"
                                                >
                                                    <div
                                                        class="modal-dialog-centered rounded-top-5"
                                                    >
                                                        <div
                                                            class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                            style="
                                                                min-height: 156px;
                                                                min-width: 350px;
                                                            "
                                                        >
                                                            <div
                                                                class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                                style="
                                                                    min-height: 100px;
                                                                    min-width: 350px;
                                                                    background: rgba(
                                                                        181,
                                                                        26,
                                                                        26,
                                                                        1
                                                                    );
                                                                "
                                                            >
                                                                <div
                                                                    class="d-flex justify-content-end w-100 p-2"
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        id="btnClose"
                                                                        class="btn"
                                                                        data-bs-dismiss="modal"
                                                                        aria-label="Close"
                                                                    >
                                                                        <img
                                                                            src="../../assets/icons/close_whaite.png"
                                                                            alt="icon"
                                                                            width="24"
                                                                            height="24"
                                                                        />
                                                                    </button>
                                                                </div>
                                                                <div
                                                                    class="p-3 text-white text-center mb-3"
                                                                    style="
                                                                        font-family: Inter,
                                                                            sans-serif;
                                                                    "
                                                                >
                                                                    <h4 class="fw-bold">
                                                                        Kontraktor Non Lokal
                                                                    </h4>
                                                                </div>
                                                            </div>
                                                            <div
                                                                class="modal-body"
                                                                style="
                                                                    height: 50vh;
                                                                    overflow-y: auto;
                                                                "
                                                            >
                                                                <div class="p-3">
                                                                    <div class="table-responsive">
                                                                        <table
                                                                            class="table mb-0"
                                                                            style="
                                                                                font-family: 'Inter-Regular',
                                                                                    serif;
                                                                            "
                                                                        >
                                                                            <thead
                                                                                style="
                                                                                    font-weight: 500;
                                                                                    font-size: 10px;
                                                                                    color: #28293d;
                                                                                "
                                                                            >
                                                                                <tr
                                                                                    class="table-danger"
                                                                                >
                                                                                    <th
                                                                                        class="p-2 text-nowrap"
                                                                                        style="
                                                                                            width: 10%;
                                                                                        "
                                                                                    >
                                                                                        No.
                                                                                    </th>
                                                                                    <th
                                                                                        class="p-2 text-nowrap"
                                                                                        style="
                                                                                            width: 90%;
                                                                                        "
                                                                                    >
                                                                                        Nama
                                                                                        Kontraktor
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody
                                                                                style="
                                                                                    font-weight: 500;
                                                                                    font-size: 10px;
                                                                                    color: #28293d;
                                                                                "
                                                                                class="p-3"
                                                                            >
                                                                                <tr
                                                                                    v-for="(
                                                                                        item, index
                                                                                    ) in mainNamaAllKontraktorNonLokal"
                                                                                    :key="index"
                                                                                >
                                                                                    <td>
                                                                                        {{
                                                                                            index +
                                                                                            1
                                                                                        }}
                                                                                    </td>
                                                                                    <td>
                                                                                        {{
                                                                                            item.toString()
                                                                                        }}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="text-black font-bold text-[11px] m-0">
                                                    {{ totalPersentasiKontraktorNonLokal }}% Non
                                                    Lokal
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="w-48 h-auto">
                                        <canvas
                                            id="KontraktorLokalNonLokal"
                                            width="10"
                                            height="10"
                                            class=""
                                        ></canvas>
                                    </div>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" lg="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <div class="flex justify-between items-center">
                                    <h5 class="text-slate-700 font-inter font-semibold text-sm">
                                        Daftar IUJP yang akan berakhir
                                    </h5>
                                    <div
                                        class="flex items-center gap-2 text-sm cursor-pointer text-red-800 font-inter font-bold"
                                        data-bs-toggle="modal"
                                        data-bs-target="#lihatLainIUJP"
                                    >
                                        <span class="underline"> Lihat Lainnya </span>
                                        <font-awesome-icon :icon="['fas', 'arrow-right-long']" />
                                    </div>

                                    <div
                                        class="modal fade rounded-top-5"
                                        id="lihatLainIUJP"
                                        tabindex="-1"
                                        aria-labelledby="lihatLainIUJP"
                                        aria-hidden="true"
                                    >
                                        <div class="modal-dialog-centered rounded-top-5">
                                            <div
                                                class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                style="min-height: 156px; min-width: 350px"
                                            >
                                                <div
                                                    class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                    style="
                                                        min-height: 100px;
                                                        min-width: 350px;
                                                        background: rgba(181, 26, 26, 1);
                                                    "
                                                >
                                                    <div
                                                        class="d-flex justify-content-end w-100 p-2"
                                                    >
                                                        <button
                                                            type="button"
                                                            id="btnClose"
                                                            class="btn"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        >
                                                            <img
                                                                src="../../assets/icons/close_whaite.png"
                                                                alt="icon"
                                                                width="24"
                                                                height="24"
                                                            />
                                                        </button>
                                                    </div>
                                                    <div
                                                        class="p-3 text-white text-center mb-3"
                                                        style="font-family: Inter, sans-serif"
                                                    >
                                                        <h4 class="fw-bold">
                                                            Daftar IUJP yang akan berakhir
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div
                                                    class="modal-body"
                                                    style="height: 50vh; overflow-y: auto"
                                                >
                                                    <div class="p-3">
                                                        <div class="table-responsive">
                                                            <table
                                                                class="table mb-0"
                                                                style="
                                                                    font-family: 'Inter-Regular',
                                                                        serif;
                                                                "
                                                            >
                                                                <thead
                                                                    style="
                                                                        font-weight: 500;
                                                                        font-size: 14px;
                                                                        color: #28293d;
                                                                    "
                                                                >
                                                                    <tr class="table-danger">
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 55%"
                                                                        >
                                                                            Nama Kontraktor
                                                                        </th>
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 45%"
                                                                        >
                                                                            Tanggal Berakhir IUJP
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody
                                                                    style="
                                                                        font-weight: 500;
                                                                        font-size: 14px;
                                                                        color: #28293d;
                                                                    "
                                                                    class="p-3"
                                                                >
                                                                    <tr
                                                                        v-for="(
                                                                            item, index
                                                                        ) in expAllIujp"
                                                                        :key="index"
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                item.namaKontraktor
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                moment(
                                                                                    item.tglExpIujp
                                                                                ).format(
                                                                                    "DD/MMM/YYYY"
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <v-table :class="{ 'mt-2': expIujp.length == 0 }">
                                        <thead>
                                            <tr class="bg-red-200">
                                                <th class="font-semibold text-sm">
                                                    Nama Kontraktor
                                                </th>
                                                <th>Tanggal Berakhir IUJP</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in expIujp" :key="index">
                                                <td>{{ item.namaKontraktor }}</td>
                                                <td>
                                                    {{
                                                        moment(item.tglExpIujp).format(
                                                            "DD/MMM/YYYY"
                                                        )
                                                    }}
                                                </td>
                                            </tr>
                                            <tr v-if="expIujp.length == 0">
                                                <td
                                                    colspan="2"
                                                    class="text-center font-semibold pt-5"
                                                >
                                                    Tidak Ada Data
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" lg="3">
                            <div
                                class="bg-white w-full border-2 rounded-lg p-2 mt-3 h-full border-dotted"
                            >
                                <div class="flex justify-between items-center">
                                    <h5 class="text-slate-700 font-inter font-semibold text-sm">
                                        Daftar CoC yang akan berakhir
                                    </h5>
                                    <div
                                        class="flex items-center gap-2 text-sm cursor-pointer text-red-800 font-inter font-bold"
                                        data-bs-toggle="modal"
                                        data-bs-target="#lihatLainExpCoc"
                                    >
                                        <span class="underline"> Lihat Lainnya </span>
                                        <font-awesome-icon :icon="['fas', 'arrow-right-long']" />
                                    </div>

                                    <div
                                        class="modal fade rounded-top-5"
                                        id="lihatLainExpCoc"
                                        tabindex="-1"
                                        aria-labelledby="lihatLainExpCoc"
                                        aria-hidden="true"
                                    >
                                        <div class="modal-dialog-centered rounded-top-5">
                                            <div
                                                class="modal-dialog modal-content card shadow-sm rounded-4 border-0"
                                                style="min-height: 156px; min-width: 500px"
                                            >
                                                <div
                                                    class="modal-content rounded-bottom-5 rounded-top-4 border-0"
                                                    style="
                                                        min-height: 100px;
                                                        min-width: 350px;
                                                        background: rgba(181, 26, 26, 1);
                                                    "
                                                >
                                                    <div
                                                        class="d-flex justify-content-end w-100 p-2"
                                                    >
                                                        <button
                                                            type="button"
                                                            id="btnClose"
                                                            class="btn"
                                                            data-bs-dismiss="modal"
                                                            aria-label="Close"
                                                        >
                                                            <img
                                                                src="../../assets/icons/close_whaite.png"
                                                                alt="icon"
                                                                width="24"
                                                                height="24"
                                                            />
                                                        </button>
                                                    </div>
                                                    <div
                                                        class="p-3 text-white text-center mb-3"
                                                        style="font-family: Inter, sans-serif"
                                                    >
                                                        <h4 class="fw-bold">
                                                            Daftar CoC yang akan berakhir
                                                        </h4>
                                                    </div>
                                                </div>
                                                <div
                                                    class="modal-body"
                                                    style="height: 55vh; overflow-y: auto"
                                                >
                                                    <div class="p-3">
                                                        <div class="table-responsive">
                                                            <table
                                                                class="table mb-0"
                                                                style="
                                                                    font-family: 'Inter-Regular',
                                                                        serif;
                                                                "
                                                            >
                                                                <thead
                                                                    style="
                                                                        font-weight: 500;
                                                                        font-size: 14px;
                                                                        color: #28293d;
                                                                    "
                                                                >
                                                                    <tr class="table-danger">
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 5%"
                                                                        >
                                                                            No
                                                                        </th>
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 25%"
                                                                        >
                                                                            Nomor CoC
                                                                        </th>
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 35%"
                                                                        >
                                                                            Nama Kontraktor
                                                                        </th>
                                                                        <th
                                                                            class="p-2 text-nowrap"
                                                                            style="width: 20%"
                                                                        >
                                                                            Tanggal Berakhir CoC
                                                                        </th>
                                                                        <th
                                                                            class="p-2 text-nowrap text-center"
                                                                            style="width: 15%"
                                                                        >
                                                                            Status
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody
                                                                    style="
                                                                        font-weight: 500;
                                                                        font-size: 14px;
                                                                        color: #28293d;
                                                                    "
                                                                    class="p-3"
                                                                >
                                                                    <tr
                                                                        v-for="(
                                                                            item, index
                                                                        ) in expAllCoc"
                                                                        :key="index"
                                                                    >
                                                                        <td>
                                                                            {{
                                                                                (cocPage - 1) * cocPerPage + index + 1
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                item.sioNumber || '-'
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                item.namaKontraktor
                                                                            }}
                                                                        </td>
                                                                        <td>
                                                                            {{
                                                                                item.masaBerlaku
                                                                                    ? moment(item.masaBerlaku).format("DD/MMM/YYYY")
                                                                                    : "-"
                                                                            }}
                                                                        </td>
                                                                        <td class="text-center">
                                                                            <span
                                                                                class="badge px-2 py-1"
                                                                                :class="item.isExpired || item.status === -4 ? 'bg-danger' : 'bg-warning text-dark'"
                                                                            >
                                                                                {{ item.isExpired || item.status === -4 ? 'Expired' : 'Akan Berakhir' }}
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                    <tr v-if="expAllCoc.length === 0">
                                                                        <td
                                                                            colspan="5"
                                                                            class="text-center font-semibold pt-5"
                                                                        >
                                                                            Tidak Ada Data
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                        <div
                                                            v-if="totalExpCoc > cocPerPage"
                                                            class="d-flex justify-content-between align-items-center mt-3 pt-2 border-top"
                                                        >
                                                            <div class="text-xs text-slate-500">
                                                                Menampilkan {{ (cocPage - 1) * cocPerPage + 1 }} - {{ Math.min(cocPage * cocPerPage, totalExpCoc) }} dari {{ totalExpCoc }} data
                                                            </div>
                                                            <div class="d-flex gap-1 align-items-center">
                                                                <button
                                                                    class="btn btn-sm btn-outline-secondary px-2 py-1 text-xs"
                                                                    :disabled="cocPage <= 1"
                                                                    @click="changeCocPage(cocPage - 1)"
                                                                >
                                                                    Prev
                                                                </button>
                                                                <span class="text-xs font-semibold px-2">
                                                                    {{ cocPage }} / {{ totalCocPages }}
                                                                </span>
                                                                <button
                                                                    class="btn btn-sm btn-outline-secondary px-2 py-1 text-xs"
                                                                    :disabled="cocPage >= totalCocPages"
                                                                    @click="changeCocPage(cocPage + 1)"
                                                                >
                                                                    Next
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-4">
                                    <v-table :class="{ 'mt-2': expCoc.length == 0 }">
                                        <thead>
                                            <tr class="bg-red-200">
                                                <th class="font-semibold text-sm">
                                                    Nama Kontraktor
                                                </th>
                                                <th>Tanggal Berakhir CoC</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in expCoc" :key="index">
                                                <td>{{ item.namaKontraktor }}</td>
                                                <td>
                                                    {{
                                                        item.masaBerlaku
                                                            ? moment(item.masaBerlaku).format("DD/MMM/YYYY")
                                                            : "-"
                                                    }}
                                                </td>
                                            </tr>
                                            <tr v-if="expCoc.length == 0">
                                                <td
                                                    colspan="2"
                                                    class="text-center font-semibold pt-5"
                                                >
                                                    Tidak Ada Data
                                                </td>
                                            </tr>
                                        </tbody>
                                    </v-table>
                                </div>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <!--End Total Contractros Donut Chart Using For Contractors -->
    </DefaultLayout>

    <ModalComponent
        id="update-no-handphone"
        title="Peringatan!"
        description="Mohon untuk lengkapi data profil anda, silahkan mengisi nomor handphone pada inputan yang tersedia di bawah."
        :button="isNoHpValid === null ? true : !isNoHpValid"
        :modalType="1"
        :btnClosed="false"
        @click-submit="submitUpdateNoHandphone"
        style="z-index: 1060"
    >
        <div class="col-md-12">
            <label for="nohp" class="form-label fs-8 fw-bold"> No Handphone </label>
            <input
                type="text"
                class="form-control fs-9"
                placeholder="Format 628xxx | Karakter min 9, Max 14"
                id="nohp"
                @input="validatePhoneEdit"
                :class="{
                    'is-invalid': isNoHpValid === false,
                    'is-valid': isNoHpValid === true,
                }"
                v-model="FormValuesEdit.noHandphone"
            />
        </div>
    </ModalComponent>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout.vue"
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"
import GlobalDataMixin from "../../GlobalDataMixin"
import Chart from "chart.js/auto"
import {
    API_BASE_URL,
    CMS_DASHBOARD,
    IUJP_EXP,
    CMS_GET_DETAILKONTRAKTOR,
    CMS_KONTRAK,
    CMS_GET_SIOID,
    CMS_DASHBOARD_SIO,
    CMS_GET_DASHBOARD_IMKP,
    CMS_GET_USER_DETAIL,
    CMS_GET_USER_UPDATE,
    CMS_GET_SIO_EXPIRING_LIST,
} from "@/constants"
import axios from "axios"
import Swal from "sweetalert2"
import ModalComponent from "@/components/ModalComponent.vue"

const url_data_dashboard = API_BASE_URL + CMS_DASHBOARD
const url_detail_kontraktor = API_BASE_URL + CMS_GET_DETAILKONTRAKTOR
const url_data_kontrak = API_BASE_URL + CMS_KONTRAK
const url_get_sioid = API_BASE_URL + CMS_GET_SIOID
const url_get_dashboard_sio = API_BASE_URL + CMS_DASHBOARD_SIO
const url_get_dashboard_imkp = API_BASE_URL + CMS_GET_DASHBOARD_IMKP
const url_get_user_detail = API_BASE_URL + CMS_GET_USER_DETAIL
const url_sio_expiring_list = API_BASE_URL + CMS_GET_SIO_EXPIRING_LIST

export default {
    name: "DashboardNewPage",
    mixins: [GlobalDataMixin],
    components: { DefaultLayout, FontAwesomeIcon, ModalComponent },
    data() {
        return {
            link: "/profile",
            linkContract: "/kontrak",
            linkSio: "/sio",
            totalKontrakAktif: 0,
            totalKontrakSelesai: 0,
            totalKontrak: 0,

            totalSubKonInti: 0,
            totalSubkonNonInti: 0,
            totalSubKontraktorIntiNon: 0,
            totalPersentasiSubKonInti: 0,
            totalPersentasiSubKonNonInti: 0,

            totalSubKontraktorLokal: 0,
            totalSubKontraktorNonlokal: 0,
            totalSubKontLokalNon: 0,
            totalSubKontraktorLokalNon: 0,
            totalPersentasiSubKonNonLokal: 0,
            totalPersentasiSubKonLokal: 0,
            totalPersentasiSubKonLokalNonLokal: 0,

            totalKontrakInternalAktif: 0,
            totalKontrakInternalSelesai: 0,
            totalKontrakInternal: 0,

            totalKontraktorInternalIntiNon: 0,
            totalKontraktorInternalInti: 0,
            totalKontraktorInternalNonInti: 0,
            totalPersentasiKonInti: 0,
            totalPersentasiKonNonInti: 0,

            totalKontraktorInternalLokalNon: 0,
            totalKontraktorInternalLokal: 0,
            totalKontraktorInternalNonLokal: 0,
            totalPersentasiKontraktorLokal: 0,
            totalPersentasiKontraktorNonLokal: 0,

            totalMainKontraktor: 0,
            totalAllKontraktor: 0,

            expIujp: [],
            rowLimit: 3,
            expAllIujp: [],
            expCoc: [],
            expAllCoc: [],
            totalExpCoc: 0,
            cocPage: 1,
            cocPerPage: 10,
            isLoadingCocExp: false,
            isModalVisible: false,
            kontraktor: [],
            isExpIujp: false,
            tglExpIujp: "",
            kontrak: [],
            ruangLingkupArr: [],
            ruangLingkupArr2: [],
            ruangLingkupArr3: [],

            kontraktorKritis: 0,
            kontraktorTinggi: 0,
            kontraktorSedang: 0,
            kontraktorRendah: 0,
            totalKontraktorbyTingkatResiko: 0,

            mainKontraktorInti: 0,
            mainKontraktorNonInti: 0,
            totalMainIntiNonInti: 0,

            mainKontraktorLokal: 0,
            mainKontraktorNonLokal: 0,
            totalMainLokalNonLokal: 0,

            mainKontraktorBesar: 0,
            mainKontraktorSedang: 0,
            mainKontraktorKecil: 0,
            totalMainKualifikasiUsaha: 0,

            totalSubKontraktor: 0,
            totalSubKontraktorInti: 0,
            totalSubKontraktorNonInti: 0,
            totalSubKontraktorLokals: 0,
            totalSubKontraktorNonLokal: 0,
            totalSubKontraktorBesar: 0,
            totalSubKontraktorSedang: 0,
            totalSubKontraktorKecil: 0,

            dataSio: [],
            progressSio: 20,
            dataDashboardSIO: {
                totalPengajuan: null,
                totalPersyaratanAdministratif: null,
                totalPembuatanJadwal: null,
                totalPresentasi: null,
                totalPemenuhanNc: null,
                totalProsesSuratPengesahan: null,
                totalSuratPengesahan: null,
                totalSioApproved: null,
                kontraktorPersyaratanAdministratif: [],
                kontraktorPembuatanJadwal: [],
                kontraktorPresentasi: [],
            },
            mainNamaKontraktorInti: [],
            mainNamaKontraktorNonInti: [],
            mainNamaKontraktorLokal: [],
            mainNamaKontraktorNonLokal: [],
            mainNamaKontraktorKritis: [],
            mainNamaKontraktorTinggi: [],
            mainNamaKontraktorSedang: [],
            mainNamaKontraktorRendah: [],
            mainNamaKontraktorUsahaBesar: [],
            mainNamaKontraktorUsahaSedang: [],
            mainNamaKontraktorUsahaKecil: [],
            mainNamaSubKontraktorInti: [],
            mainNamaSubKontraktorNonInti: [],
            mainNamaSubKontraktorLokal: [],
            mainNamaSubKontraktorNonLokal: [],
            mainNamaSubKontraktorBesar: [],
            mainNamaSubKontraktorSedang: [],
            mainNamaSubKontraktorKecil: [],
            mainNamaAllKontraktorInti: [],
            mainNamaAllKontraktorNonInti: [],
            mainNamaAllKontraktorLokal: [],
            mainNamaAllKontraktorNonLokal: [],

            dataDashboardImkp: {
                totalImkp: 0,
                totalImkpUnderReview: 0,
                totalNeedRevision: 0,
                totalDocumentComplete: 0,
                totalProsesPenerbitanImkp: 0,
                totalImkpPublished: 0,
                totalProccessBast: 0,
                totalBastDone: 0,
            },
            userDetail: null,
            FormValuesEdit: {
                userId: "",
                email: "",
                kontraktorId: null,
                noHandphone: "",
            },
            isNoHpValid: null,
        }
    },
    computed: {
        totalCocPages() {
            return Math.ceil(this.totalExpCoc / this.cocPerPage) || 1
        },
    },
    mounted() {
        this.fetchDataDashboard()
        this.ChartRenderInternal()
        this.ChartKontraktor()
        this.dataIujpExp()
        this.dataCocExp()
        this.fetchDataKontraktor()
        this.getSioID()
        this.ChartTotalSIO()
        this.totalImkp()
        if (this.userData.kontraktorID) {
            this.getUserDetail()
        }
        if (this.$route.query.openCocExpiredDialog) {
            this.$nextTick(() => this.openCocExpiredDialog())
        }
    },
    methods: {
        showModal() {
            this.isModalVisible = true
        },
        hideModal() {
            this.isModalVisible = false
        },
        filteredItems() {
            // Adjust the condition based on your requirement
            return this.ruangLingkupArr3.filter((item) => item.length > 0)
        },
        getInitials(fullName) {
            if (fullName && typeof fullName === "string") {
                const words = fullName.split(" ")
                let initials = ""

                if (words.length === 1) {
                    initials = words[0].substring(0, 2).toUpperCase()
                } else {
                    for (let i = 0; i < 2 && i < words.length; i++) {
                        initials += words[i].charAt(0).toUpperCase()
                    }
                }
                return initials
            } else {
                return ""
            }
        },
        fetchDataKontraktor() {
            if (this.userData.kontraktorID != null) {
                axios
                    .get(url_detail_kontraktor + this.userData.kontraktorID, {
                        headers: { accept: "application/json" },
                    })
                    .then((response) => {
                        this.kontraktor = response.data.detailKontraktor
                        this.tglExpIujp = moment(response.data.detailKontraktor.masaBerlaku).format(
                            "YYYY-MM-DD"
                        )
                        const currentDate = new Date()
                        const sixMonthsLaterDate = new Date()
                        const resultDate = sixMonthsLaterDate.setMonth(currentDate.getMonth() + 6)
                        if (this.tglExpIujp < moment(resultDate).format("YYYY-MM-DD")) {
                            this.isExpIujp = true
                        }
                        // set value form edit
                    })
                    .catch((error) => {
                        alert("Error Fetch Data List Kontraktor : " + error.message)
                        console.error("Error fetching data:", error)
                    })
            }
        },
        fetchDataDashboard() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    if (this.userData.kontraktorID != null) {
                        this.totalKontrakAktif = JSON.stringify(
                            response.data.dataKontraktor.totalKontrakAktif
                        )
                        this.totalKontrakSelesai = JSON.stringify(
                            response.data.dataKontraktor.totalKontrakNonAktif
                        )
                        this.totalKontrak =
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalKontrakAktif)
                            ) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalKontrakNonAktif)
                            )

                        let totalSubKont =
                            parseInt(JSON.stringify(response.data.dataKontraktor.totalSubkonInti)) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonInti)
                            )
                        this.totalSubKontraktorIntiNon = totalSubKont
                        this.totalPersentasiSubKonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonInti)
                            ) /
                                (totalSubKont == 0 ? 1 : totalSubKont)) *
                                100
                        )
                        this.totalPersentasiSubKonNonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonInti)
                            ) /
                                (totalSubKont == 0 ? 1 : totalSubKont)) *
                                100
                        )

                        let totalSubKontLokalNon =
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonLokal)
                            ) +
                            parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonLokal)
                            )
                        this.totalSubKontraktorNonlokal = JSON.stringify(
                            response.data.dataKontraktor.totalSubkonNonLokal
                        )
                        this.totalSubKontraktorLokalNon = totalSubKontLokalNon
                        this.totalPersentasiSubKonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonLokal)
                            ) /
                                (totalSubKontLokalNon == 0 ? 1 : totalSubKontLokalNon)) *
                                100
                        )
                        this.totalPersentasiSubKonNonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataKontraktor.totalSubkonNonLokal)
                            ) /
                                (totalSubKontLokalNon == 0 ? 1 : totalSubKontLokalNon)) *
                                100
                        )

                        // fetch data kontrak
                        var bodyJson = {
                            header: {
                                page: 1,
                                perPage: 1000,
                                usecase:
                                    this.userData.kontraktorID != null ? "kontraktor" : "isafe",
                            },
                            kontraktorID:
                                this.userData.kontraktorID != null
                                    ? this.userData.kontraktorID
                                    : null,
                        }
                        const user = localStorage.getItem("user_cms")
                        const tokens = JSON.parse(user)
                        const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
                        var config = {
                            headers: {
                                role: role,
                                Authorization: `Bearer ${tokens.token}`,
                                Accept: "application/json",
                                "Access-Control-Allow-Origin": "*",
                                "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                                "Access-Control-Allow-Headers":
                                    "Content-Type, Authorization, Accept",
                            },
                        }
                        console.log("body:", bodyJson)
                        axios
                            .post(url_data_kontrak, bodyJson, config)
                            .then((response) => {
                                this.kontrak = response.data.data
                                this.ruangLingkupArr = response.data.data.map((item) => ({
                                    ...item,
                                    descriptionLine: item.ruangLingkup.split("\n"),
                                }))
                                this.ruangLingkupArr.forEach((item) => {
                                    if (item.descriptionLine.length > 1) {
                                        this.ruangLingkupArr2.push(item.descriptionLine)
                                    } else if (item.ruangLingkup !== "") {
                                        this.ruangLingkupArr2.push(item.ruangLingkup)
                                    }
                                })
                                console.log("arr 1", this.ruangLingkupArr)
                                console.log("arr 2", this.ruangLingkupArr2)
                                this.ruangLingkupArr3 = [].concat(
                                    ...this.ruangLingkupArr2.map((obj) => obj)
                                )
                            })
                            .catch((error) => {
                                if (error.responsestatus != 400) {
                                    alert("Error Fetch Data List Kontrak : " + error.message)
                                    console.error("Error fetching data:", error)
                                } else {
                                    this.kontrak = []
                                }
                            })
                    } else {
                        this.totalKontrakInternalAktif = JSON.stringify(
                            response.data.dataInternal.totalKontrakAktif
                        )
                        this.totalKontrakInternalSelesai = JSON.stringify(
                            response.data.dataInternal.totalKontrakNonAktif
                        )
                        this.totalKontrakInternal =
                            parseInt(JSON.stringify(response.data.dataInternal.totalKontrakAktif)) +
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontrakNonAktif)
                            )
                        this.totalKontraktorInternalIntiNon =
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                            ) + parseInt(response.data.dataInternal.totalKontraktorNonInti)
                        this.totalPersentasiKonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonInti))) *
                                100
                        )
                        this.totalPersentasiKonNonInti = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorNonInti)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorInti)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonInti))) *
                                100
                        )

                        this.totalKontraktorInternalLokalNon =
                            parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                            ) + parseInt(response.data.dataInternal.totalKontraktorNonLokal)
                        this.totalPersentasiKontraktorLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonLokal))) *
                                100
                        )
                        this.totalPersentasiKontraktorNonLokal = Math.round(
                            (parseInt(
                                JSON.stringify(response.data.dataInternal.totalKontraktorNonLokal)
                            ) /
                                (parseInt(
                                    JSON.stringify(response.data.dataInternal.totalKontraktorLokal)
                                ) +
                                    parseInt(response.data.dataInternal.totalKontraktorNonLokal))) *
                                100
                        )
                        this.kontraktorKritis = parseInt(
                            JSON.stringify(response.data.dataInternal.totalKontraktorKritis)
                        )
                        this.kontraktorTinggi = parseInt(
                            JSON.stringify(response.data.dataInternal.totalKontraktorTinggi)
                        )
                        this.kontraktorSedang = parseInt(
                            JSON.stringify(response.data.dataInternal.totalKontraktorSedang)
                        )
                        this.kontraktorRendah = parseInt(
                            JSON.stringify(response.data.dataInternal.totalKontraktorRendah)
                        )
                        this.totalKontraktorbyTingkatResiko =
                            this.kontraktorKritis +
                            this.kontraktorTinggi +
                            this.kontraktorSedang +
                            this.kontraktorRendah

                        this.mainKontraktorInti = parseInt(
                            JSON.stringify(response.data.dataInternal.totalMainKontraktorInti)
                        )
                        this.mainKontraktorNonInti = parseInt(
                            JSON.stringify(response.data.dataInternal.totalMainKontraktorNonInti)
                        )
                        this.totalMainIntiNonInti =
                            this.mainKontraktorInti + this.mainKontraktorNonInti
                        this.mainNamaKontraktorInti =
                            response.data.dataInternal.mainKontraktorInti.split(",")
                        this.mainNamaKontraktorNonInti =
                            response.data.dataInternal.mainKontraktorNonInti.split(",")
                        this.mainKontraktorLokal = parseInt(
                            JSON.stringify(response.data.dataInternal.totalMainKontraktorLokal)
                        )
                        this.mainKontraktorNonLokal = parseInt(
                            JSON.stringify(response.data.dataInternal.totalMainKontraktorNonLokal)
                        )
                        this.totalMainLokalNonLokal =
                            this.mainKontraktorLokal + this.mainKontraktorNonLokal
                        this.totalMainKontraktor = parseInt(
                            JSON.stringify(response.data.dataInternal.totalMainKontraktor)
                        )
                        this.totalAllKontraktor = parseInt(
                            JSON.stringify(response.data.dataInternal.totalKontraktor)
                        )
                        this.mainNamaAllKontraktorInti =
                            response.data.dataInternal.allKontraktorInti.split(",")
                        this.mainNamaAllKontraktorNonInti =
                            response.data.dataInternal.allKontraktorNonInti.split(",")
                        this.mainNamaAllKontraktorLokal =
                            response.data.dataInternal.allKontrakotrLokal.split(",")
                        this.mainNamaAllKontraktorNonLokal =
                            response.data.dataInternal.allKontraktorNonLokal.split(",")
                        this.mainNamaKontraktorLokal =
                            response.data.dataInternal.mainKontraktorLokal.split(",")
                        this.mainNamaKontraktorNonLokal =
                            response.data.dataInternal.mainKontraktorNonLokal.split(",")
                        this.mainNamaKontraktorKritis =
                            response.data.dataInternal.mainKontraktorTrKritis != null
                                ? response.data.dataInternal.mainKontraktorTrKritis.split(",")
                                : null
                        this.mainNamaKontraktorTinggi =
                            response.data.dataInternal.mainKontraktorTrTinggi != null
                                ? response.data.dataInternal.mainKontraktorTrTinggi.split(",")
                                : null
                        this.mainNamaKontraktorSedang =
                            response.data.dataInternal.mainKontraktorTrSedang != null
                                ? response.data.dataInternal.mainKontraktorTrSedang.split(",")
                                : null
                        this.mainNamaKontraktorRendah =
                            response.data.dataInternal.mainKontraktorTrRendah != null
                                ? response.data.dataInternal.mainKontraktorTrRendah.split(",")
                                : null
                    }
                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })
        },
        dataIujpExp() {
            var bodyJson = {
                page: 1,
                perPage: 3,
                usecase: "isafe",
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            axios
                .post(API_BASE_URL + IUJP_EXP, bodyJson, {
                    headers: {
                        role: "isafe",
                        Authorization: `Bearer ${tokens.token}`,
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                    },
                })
                .then((res) => {
                    this.expIujp = res.data.data.slice(0, this.rowLimit)
                    this.expAllIujp = res.data.data
                })
                .catch(() => {
                    console.log("error fetch data")
                })
        },
        dataCocExp(page = 1, perPage = 10) {
            this.isLoadingCocExp = true
            const user = localStorage.getItem("user_cms")
            const tokens = user ? JSON.parse(user) : {}
            axios
                .get(url_sio_expiring_list, {
                    params: {
                        page: page,
                        perPage: perPage,
                    },
                    headers: {
                        role: "isafe",
                        Authorization: `Bearer ${tokens.token}`,
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                    },
                })
                .then((res) => {
                    const data = res.data?.data || []
                    this.expCoc = data.slice(0, this.rowLimit)
                    this.expAllCoc = data
                    this.totalExpCoc = res.data?.total != null ? res.data.total : data.length
                    this.cocPage = page
                    this.cocPerPage = perPage
                    this.isLoadingCocExp = false
                })
                .catch((err) => {
                    console.error("error fetch data COC expiring list", err)
                    this.isLoadingCocExp = false
                })
        },
        changeCocPage(newPage) {
            if (newPage >= 1 && newPage <= this.totalCocPages) {
                this.dataCocExp(newPage, this.cocPerPage)
            }
        },
        openCocExpiredDialog() {
            let button = document.createElement("a")
            button.setAttribute("data-bs-toggle", "modal")
            button.setAttribute("data-bs-target", "#lihatLainExpCoc")
            document.body.appendChild(button)
            button.click()
            button.remove()
            this.$router.replace({ query: {} })
        },
        ChartKontraktor() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    this.totalSubKonInti = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonInti
                    )
                    this.totalSubkonNonInti = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonNonInti
                    )
                    this.totalSubKontraktorNonlokal = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonNonLokal
                    )
                    this.totalSubKontraktorLokal = JSON.stringify(
                        response.data.dataKontraktor.totalSubkonLokal
                    )

                    const KontraktorLokalNonLokal =
                        document.getElementById("SubKonLokalSubNonLokal")
                    const DataOptionsKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Subkontraktor",
                                data: [
                                    this.totalSubKontraktorLokal,
                                    this.totalSubKontraktorNonlokal,
                                ],
                                backgroundColor: ["rgba(255, 136, 0, 1)", "rgba(252, 204, 117, 1)"],
                                hoverOffset: 4,
                            },
                        ],
                    }
                    const OptionsKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    KontraktorLokalNonLokal
                        ? new Chart(KontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsKontraktorLokalNonLokal,
                              options: OptionsKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Kontraktor Lokal dan Non-Lokal */

                    /* Chart Kontraktor Inti dan Non-Inti */
                    const IntiNonInti = document.getElementById("SubKontIntiNonInti")
                    const a = this.totalSubKonInti
                    const b = this.totalSubkonNonInti
                    const data = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Subkontraktor",
                                data: [a, b],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const option = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }

                    IntiNonInti
                        ? new Chart(IntiNonInti, {
                              type: "doughnut",
                              data: data,
                              options: option,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Kontraktor Inti dan Non-Inti */
                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })
        },

        ChartRenderInternal() {
            let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            if (this.userData.kontraktorID != null) {
                bodyJSONCreate = {
                    role: "kontraktor",
                    kontraktorId: this.userData.kontraktorID,
                }
            }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .post(url_data_dashboard, bodyJSONCreate, config)
                .then((response) => {
                    this.totalKontraktorInternalInti = JSON.stringify(
                        response.data.dataInternal.totalKontraktorInti
                    )
                    this.totalKontraktorInternalNonInti = JSON.stringify(
                        response.data.dataInternal.totalKontraktorNonInti
                    )
                    this.totalKontraktorInternalLokal = JSON.stringify(
                        response.data.dataInternal.totalKontraktorLokal
                    )
                    this.totalKontraktorInternalNonLokal = JSON.stringify(
                        response.data.dataInternal.totalKontraktorNonLokal
                    )
                    this.kontraktorKritis = JSON.stringify(
                        response.data.dataInternal.totalKontraktorKritis
                    )
                    this.kontraktorTinggi = JSON.stringify(
                        response.data.dataInternal.totalKontraktorTinggi
                    )
                    this.kontraktorSedang = JSON.stringify(
                        response.data.dataInternal.totalKontraktorSedang
                    )
                    this.kontraktorRendah = JSON.stringify(
                        response.data.dataInternal.totalKontraktorRendah
                    )
                    this.mainKontraktorInti = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorInti
                    )
                    this.mainKontraktorNonInti = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorNonInti
                    )
                    this.mainKontraktorLokal = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorLokal
                    )
                    this.mainKontraktorNonLokal = JSON.stringify(
                        response.data.dataInternal.totalMainKontraktorNonLokal
                    )
                    this.mainKontraktorBesar = parseInt(
                        JSON.stringify(response.data.dataInternal.totalMainKontraktorBesar)
                    )
                    this.mainKontraktorSedang = parseInt(
                        JSON.stringify(response.data.dataInternal.totalMainKontraktorSedang)
                    )
                    this.mainKontraktorKecil = parseInt(
                        JSON.stringify(response.data.dataInternal.totalMainKontraktorKecil)
                    )
                    this.totalMainKualifikasiUsaha =
                        this.mainKontraktorBesar +
                        this.mainKontraktorSedang +
                        this.mainKontraktorKecil
                    this.mainNamaKontraktorUsahaBesar =
                        response.data.dataInternal.mainKontraktorBesar != null
                            ? response.data.dataInternal.mainKontraktorBesar.split(",")
                            : null
                    this.mainNamaKontraktorUsahaSedang =
                        response.data.dataInternal.mainKontraktorSedang != null
                            ? response.data.dataInternal.mainKontraktorSedang.split(",")
                            : null
                    this.mainNamaKontraktorUsahaKecil =
                        response.data.dataInternal.mainKontraktorKecil != null
                            ? response.data.dataInternal.mainKontraktorKecil.split(",")
                            : null
                    this.totalSubKontraktor = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktor)
                    )
                    this.totalSubKontraktorInti = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorInti)
                    )
                    this.totalSubKontraktorNonInti = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorNonInti)
                    )
                    this.totalSubKontraktorLokals = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorLokal)
                    )
                    this.totalSubKontraktorNonLokal = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorNonLokal)
                    )
                    this.totalSubKontraktorBesar = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorBesar)
                    )
                    this.totalSubKontraktorSedang = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorSedang)
                    )
                    this.totalSubKontraktorKecil = parseInt(
                        JSON.stringify(response.data.dataInternal.totalSubKontraktorKecil)
                    )
                    this.mainNamaSubKontraktorInti =
                        response.data.dataInternal.subKontraktorInti != null
                            ? response.data.dataInternal.subKontraktorInti.split(",")
                            : null
                    this.mainNamaSubKontraktorNonInti =
                        response.data.dataInternal.subKontraktorNonInti != null
                            ? response.data.dataInternal.subKontraktorNonInti.split(",")
                            : null
                    this.mainNamaSubKontraktorLokal =
                        response.data.dataInternal.subKontraktorLokal != null
                            ? response.data.dataInternal.subKontraktorLokal.split(",")
                            : null
                    this.mainNamaSubKontraktorNonLokal =
                        response.data.dataInternal.subKontraktorNonLokal != null
                            ? response.data.dataInternal.subKontraktorNonLokal.split(",")
                            : null
                    this.mainNamaSubKontraktorBesar =
                        response.data.dataInternal.subKontraktorBesar != null
                            ? response.data.dataInternal.subKontraktorBesar.split(",")
                            : null
                    this.mainNamaSubKontraktorSedang =
                        response.data.dataInternal.subKontraktorSedang != null
                            ? response.data.dataInternal.subKontraktorSedang.split(",")
                            : null
                    this.mainNamaSubKontraktorKecil =
                        response.data.dataInternal.subKontraktorKecil != null
                            ? response.data.dataInternal.subKontraktorKecil.split(",")
                            : null
                    /* Chart Kontraktor Inti dan Non-Inti */
                    const IntiNonInti = document.getElementById("KontraktorIntiNonInti")
                    const data = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.totalKontraktorInternalInti,
                                    this.totalKontraktorInternalNonInti,
                                ],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const option = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }

                    IntiNonInti
                        ? new Chart(IntiNonInti, {
                              type: "doughnut",
                              data: data,
                              options: option,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Kontraktor Inti dan Non-Inti */

                    /* Chart Kontraktor Lokal dan Non-Lokal */
                    const KontraktorLokalNonLokal =
                        document.getElementById("KontraktorLokalNonLokal")
                    const DataOptionsKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.totalKontraktorInternalLokal,
                                    this.totalKontraktorInternalNonLokal,
                                ],
                                backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    KontraktorLokalNonLokal
                        ? new Chart(KontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsKontraktorLokalNonLokal,
                              options: OptionsKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Kontraktor Lokal dan Non-Lokal */

                    /* Chart Kontraktor Tingkat Resiko */
                    const kontraktorTingkatResiko =
                        document.getElementById("kontraktorTingkatResiko")
                    const dataKontTingkatResiko = {
                        labels: ["Kritis", "Tinggi", "Sedang", "Rendah"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.kontraktorKritis,
                                    this.kontraktorTinggi,
                                    this.kontraktorSedang,
                                    this.kontraktorRendah,
                                ],
                                backgroundColor: [
                                    "rgba(181,26,26,1)",
                                    "rgba(255, 92, 92, 1)",
                                    "rgba(87,235,161, 1)",
                                    "rgb(252,204,117,1)",
                                ],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const optionTingkatReesiko = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }

                    kontraktorTingkatResiko
                        ? new Chart(kontraktorTingkatResiko, {
                              type: "doughnut",
                              data: dataKontTingkatResiko,
                              options: optionTingkatReesiko,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Kontraktor Inti dan Non-Inti */

                    /* Chart Main Kontraktor Inti dan Non-Inti */
                    const mainIntiNonInti = document.getElementById("mainKontraktorIntiNonInti")
                    const dataMainIntiNonInti = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [this.mainKontraktorInti, this.mainKontraktorNonInti],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 10,
                            },
                        ],
                    }
                    const optionMainIntiNonInti = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 100,
                    }

                    mainIntiNonInti
                        ? new Chart(mainIntiNonInti, {
                              type: "doughnut",
                              data: dataMainIntiNonInti,
                              options: optionMainIntiNonInti,
                          })
                        : console.log("Elemen Chart Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Main Kontraktor Inti dan Non-Inti */

                    /* Chart Main Kontraktor Lokal dan Non-Lokal */
                    const mainKontraktorLokalNonLokal = document.getElementById(
                        "mainKontraktorLokalNonLokal"
                    )
                    const DataOptionsMainKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [this.mainKontraktorLokal, this.mainKontraktorNonLokal],
                                backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsMainKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    mainKontraktorLokalNonLokal
                        ? new Chart(mainKontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsMainKontraktorLokalNonLokal,
                              options: OptionsMainKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Main Kontraktor Lokal dan Non-Lokal */

                    /* Chart Main Kontraktor Kualifikasi Usaha */
                    const mainKontraktorKualifikasiUsaha = document.getElementById(
                        "mainKontraktorKualifikasiUsaha"
                    )
                    const DataOptionsmainKontraktorKualifikasiUsaha = {
                        labels: ["Kecil", "Sedang", "Besar"],
                        datasets: [
                            {
                                label: "Total Kontraktor",
                                data: [
                                    this.mainKontraktorKecil,
                                    this.mainKontraktorSedang,
                                    this.mainKontraktorBesar,
                                ],
                                backgroundColor: [
                                    "rgb(246,133,133)",
                                    "rgb(243,86,86)",
                                    "rgb(222,156,159)",
                                ],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsMainKontraktorKualifikasiUsaha = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    mainKontraktorKualifikasiUsaha
                        ? new Chart(mainKontraktorKualifikasiUsaha, {
                              type: "doughnut",
                              data: DataOptionsmainKontraktorKualifikasiUsaha,
                              options: OptionsMainKontraktorKualifikasiUsaha,
                          })
                        : console.log("Elemen Chart Kontraktor Kualifikasi Usaha tidak ditemukan")
                    /* End Chart Main Kontraktor Lokal dan Non-Lokal */

                    /* Chart Sub Kontraktor Inti dan Non-Inti */
                    const subIntiNonInti = document.getElementById("subKontraktorIntiNonInti")
                    const dataSubIntiNonInti = {
                        labels: ["Inti", "Non Inti"],
                        datasets: [
                            {
                                label: "Total Sub Kontraktor",
                                data: [this.totalSubKontraktorInti, this.totalSubKontraktorNonInti],
                                backgroundColor: ["rgba(181, 26, 26, 1)", "rgba(255, 128, 128, 1)"],
                                hoverOffset: 10,
                            },
                        ],
                    }
                    const optionSubIntiNonInti = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 100,
                    }

                    subIntiNonInti
                        ? new Chart(subIntiNonInti, {
                              type: "doughnut",
                              data: dataSubIntiNonInti,
                              options: optionSubIntiNonInti,
                          })
                        : console.log("Elemen Chart Sub Kontraktor Inti Non Inti tidak ditemukan")

                    /* End Chart Sub Kontraktor Inti dan Non-Inti */

                    /* Chart Sub Kontraktor Lokal dan Non-Lokal */
                    const subKontraktorLokalNonLokal = document.getElementById(
                        "subKontraktorLokalNonLokal"
                    )
                    const DataOptionsSubKontraktorLokalNonLokal = {
                        labels: ["Lokal", "Non Lokal"],
                        datasets: [
                            {
                                label: "Total Sub Kontraktor",
                                data: [
                                    this.totalSubKontraktorLokals,
                                    this.totalSubKontraktorNonLokal,
                                ],
                                backgroundColor: ["rgba(252, 204, 117, 1)", "rgba(255, 136, 0, 1)"],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsSubKontraktorLokalNonLokal = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    subKontraktorLokalNonLokal
                        ? new Chart(subKontraktorLokalNonLokal, {
                              type: "doughnut",
                              data: DataOptionsSubKontraktorLokalNonLokal,
                              options: OptionsSubKontraktorLokalNonLokal,
                          })
                        : console.log("Elemen Chart Sub Kontraktor Lokal Non Lokal tidak ditemukan")
                    /* End Chart Sub Kontraktor Lokal dan Non-Lokal */

                    /* Chart Sub Kontraktor Kualifikasi Usaha */
                    const subKontraktorKualifikasiUsaha = document.getElementById(
                        "subKontraktorKualifikasiUsaha"
                    )
                    const DataOptionsSubKontraktorKualifikasiUsaha = {
                        labels: ["Besar", "Sedang", "Kecil"],
                        datasets: [
                            {
                                label: "Total Sub Kontraktor",
                                data: [
                                    this.totalSubKontraktorBesar,
                                    this.totalSubKontraktorSedang,
                                    this.totalSubKontraktorKecil,
                                ],
                                backgroundColor: [
                                    "rgb(222,156,159)",
                                    "rgb(246,133,133)",
                                    "rgb(243,86,86)",
                                ],
                                hoverOffset: 6,
                            },
                        ],
                    }
                    const OptionsSubKontraktorKualifikasiUsaha = {
                        plugins: {
                            legend: {
                                position: "button",
                            },
                        },
                        cutoutPercentage: 80,
                    }
                    subKontraktorKualifikasiUsaha
                        ? new Chart(subKontraktorKualifikasiUsaha, {
                              type: "doughnut",
                              data: DataOptionsSubKontraktorKualifikasiUsaha,
                              options: OptionsSubKontraktorKualifikasiUsaha,
                          })
                        : console.log(
                              "Elemen Chart Sub Kontraktor Kualifikasi Usaha tidak ditemukan"
                          )
                    /* End Chart Main Kontraktor Lokal dan Non-Lokal */
                })
                .catch((error) => {
                    console.error("Error fetching data:", error)
                })
        },

        ChartTotalSIO() {
            // let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            // if (this.userData.kontraktorID != null) {
            //     bodyJSONCreate = {
            //         role: "kontraktor",
            //         kontraktorId: this.userData.kontraktorID,
            //     }
            // }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .get(url_get_dashboard_sio, config)
                .then((response) => {
                    console.log("reseponse getDashboardSIO:", response)
                    // set value form edit

                    this.dataDashboardSIO.totalPersyaratanAdministratif =
                        response.data.totalPersyaratanAdministratif !== null
                            ? parseInt(response.data.totalPersyaratanAdministratif)
                            : 0
                    this.dataDashboardSIO.totalPembuatanJadwal =
                        response.data.totalPembuatanJadwal !== null
                            ? parseInt(response.data.totalPembuatanJadwal)
                            : 0
                    this.dataDashboardSIO.totalPresentasi =
                        response.data.totalPresentasi !== null
                            ? parseInt(response.data.totalPresentasi)
                            : 0
                    this.dataDashboardSIO.totalPemenuhanNc =
                        response.data.totalPemenuhanNc !== null
                            ? parseInt(response.data.totalPemenuhanNc)
                            : 0
                    this.dataDashboardSIO.totalProsesSuratPengesahan =
                        response.data.totalSuratPengesahan !== null
                            ? parseInt(response.data.totalProsesSuratPengesahan)
                            : 0
                    this.dataDashboardSIO.totalSuratPengesahan =
                        response.data.totalSuratPengesahan !== null
                            ? parseInt(response.data.totalSuratPengesahan)
                            : 0
                    this.dataDashboardSIO.totalSioApproved =
                        response.data.totalSioApproved !== null
                            ? parseInt(response.data.totalSioApproved)
                            : 0
                    this.dataDashboardSIO.totalPengajuan = parseInt(
                        this.dataDashboardSIO.totalPersyaratanAdministratif +
                            this.dataDashboardSIO.totalPembuatanJadwal +
                            this.dataDashboardSIO.totalPresentasi +
                            this.dataDashboardSIO.totalPemenuhanNc +
                            this.dataDashboardSIO.totalProsesSuratPengesahan +
                            this.dataDashboardSIO.totalSuratPengesahan +
                            this.dataDashboardSIO.totalSioApproved
                    )

                    console.log("datachart:", [
                        this.dataDashboardSIO.totalPersyaratanAdministratif,
                        this.dataDashboardSIO.totalPembuatanJadwal,
                        this.dataDashboardSIO.totalPresentasi,
                        this.dataDashboardSIO.totalPemenuhanNc,
                        this.dataDashboardSIO.totalSuratPengesahan,
                        this.dataDashboardSIO.totalSioApproved,
                    ])

                    const data = {
                        labels: [
                            "Persyaratan Administratif",
                            "Pembuatan Jadwal Presentasi",
                            "Presentasi Calon PJO",
                            "Pemenuhan NC Calon PJO",
                            "Surat Pengesahan PJO",
                            "CoC Approved",
                        ],
                        datasets: [
                            {
                                label: "Total CoC",
                                backgroundColor: "rgba(255, 99, 132, 0.2)",
                                borderColor: "rgba(255, 99, 132, 1)",
                                borderWidth: 1,
                                data: [
                                    this.dataDashboardSIO.totalPersyaratanAdministratif,
                                    this.dataDashboardSIO.totalPembuatanJadwal,
                                    this.dataDashboardSIO.totalPresentasi,
                                    this.dataDashboardSIO.totalPemenuhanNc,
                                    this.dataDashboardSIO.totalSuratPengesahan,
                                    this.dataDashboardSIO.totalSioApproved,
                                ],
                            },
                        ],
                    }
                    const totalValue = data.datasets[0].data.reduce((acc, curr) => acc + curr, 0)

                    const TotalSIOPerStatus = document.getElementById("TotalSIOPerStatus")

                    TotalSIOPerStatus
                        ? new Chart(TotalSIOPerStatus, {
                              type: "bar",
                              data: data,
                              options: {
                                  plugins: {
                                      title: {
                                          display: false,
                                          text: "Bar Chart with Total Value",
                                      },
                                      legend: {
                                          display: false,
                                      },
                                      annotation: {
                                          annotations: [
                                              {
                                                  type: "line",
                                                  mode: "horizontal",
                                                  scaleID: "y",
                                                  value: totalValue,
                                                  borderColor: "rgb(75, 192, 192)",
                                                  borderWidth: 2,
                                                  label: {
                                                      enabled: true,
                                                      content: "Total Pengajuan CoC: " + totalValue,
                                                      position: "right",
                                                  },
                                              },
                                          ],
                                      },
                                      tooltips: {
                                          enabled: false,
                                      },
                                  },
                                  scales: {
                                      xAxes: [
                                          {
                                              ticks: {
                                                  fontSize: 8, // Adjust the font size of x-axis labels
                                              },
                                          },
                                      ],
                                      yAxes: [
                                          {
                                              ticks: {
                                                  callback: function (value) {
                                                      return value
                                                  },
                                                  fontSize: 8, // Adjust the font size of y-axis labels
                                              },
                                          },
                                      ],
                                  },
                              },
                          })
                        : console.log("Elemen Chart Kontraktor Lokal Non Lokal tidak ditemukan")
                })
                .catch((error) => {
                    alert("Error Fetch getDashboardSIO : " + error.message)
                    console.error("Error getDashboardSIO :", error)
                })

            // start draw chart
            this.$nextTick(function () {
                // DOM is now updated
                // `this` is bound to the current instance
            })

            // end draw chart
        },
        getSioID() {
            if (this.userData.kontraktorID != null) {
                axios
                    .get(url_get_sioid + this.userData.kontraktorID, {
                        headers: {
                            role: this.userData.role,
                            Authorization: "Bearer " + this.userData.token,
                            // accept: "*/*",
                            Accept: "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                            "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                        },
                    })
                    .then((response) => {
                        if (response.data.data != null) {
                            this.dataSio = response.data.data
                            console.log("data sio nya = ", this.dataSio.status)
                        }
                    })
                    .catch((error) => {
                        this.isLoading = false
                        alert("Error Fetch Data getSioID : " + error.message)
                        console.error("Error fetching data getSioID :", error.message)
                    })
            }
        },
        totalImkp() {
            // let bodyJSONCreate = { role: "isafe", kontraktorId: null }
            // if (this.userData.kontraktorID != null) {
            //     bodyJSONCreate = {
            //         role: "kontraktor",
            //         kontraktorId: this.userData.kontraktorID,
            //     }
            // }
            const user = localStorage.getItem("user_cms")
            const tokens = JSON.parse(user)
            const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
            let config = {
                headers: {
                    role: role,
                    Authorization: `Bearer ${tokens.token}`,
                    Accept: "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                    "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                },
            }
            axios
                .get(url_get_dashboard_imkp, config)
                .then((response) => {
                    console.log("reseponse getDashboardImkp:", response)
                    // set value form edit

                    this.dataDashboardImkp.totalImkpUnderReview =
                        response.data.totalUnderReview !== null
                            ? parseInt(response.data.totalUnderReview)
                            : 0
                    this.dataDashboardImkp.totalNeedRevision =
                        response.data.totalNeedRevision !== null
                            ? parseInt(response.data.totalNeedRevision)
                            : 0
                    this.dataDashboardImkp.totalDocumentComplete =
                        response.data.totalDocumentComplete !== null
                            ? parseInt(response.data.totalDocumentComplete)
                            : 0
                    this.dataDashboardImkp.totalProsesPenerbitanImkp =
                        response.data.totalProsesPenerbitanImkp !== null
                            ? parseInt(response.data.totalProsesPenerbitanImkp)
                            : 0
                    this.dataDashboardImkp.totalImkpPublished =
                        response.data.totalImkpPublished !== null
                            ? parseInt(response.data.totalImkpPublished)
                            : 0
                    this.dataDashboardImkp.totalProccessBast =
                        response.data.totalProccessBast !== null
                            ? parseInt(response.data.totalProccessBast)
                            : 0
                    this.dataDashboardImkp.totalBastDone =
                        response.data.totalBastDone !== null
                            ? parseInt(response.data.totalBastDone)
                            : 0
                    this.dataDashboardImkp.totalImkp = parseInt(
                        this.dataDashboardImkp.totalImkpUnderReview +
                            this.dataDashboardImkp.totalNeedRevision +
                            this.dataDashboardImkp.totalDocumentComplete +
                            this.dataDashboardImkp.totalProsesPenerbitanImkp +
                            this.dataDashboardImkp.totalImkpPublished +
                            this.dataDashboardImkp.totalProccessBast +
                            this.dataDashboardImkp.totalBastDone
                    )
                })
                .catch((error) => {
                    alert("Error Fetch getDashboardSIO : " + error.message)
                    console.error("Error getDashboardSIO :", error)
                })

            // start draw chart
            this.$nextTick(function () {
                // DOM is now updated
                // `this` is bound to the current instance
            })

            // end draw chart
        },
        async getUserDetail() {
            try {
                const user_id = this.userData.userId
                const user = localStorage.getItem("user_cms")
                const tokens = JSON.parse(user)
                const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
                let params = {
                    userId: user_id,
                }
                const result = await axios.get(url_get_user_detail, {
                    params: params,
                    headers: {
                        role: role,
                        Authorization: `Bearer ${tokens.token}`,
                        Accept: "application/json",
                        "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                        "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                    },
                })
                const res = result.data
                if (!res.users.noHandphone || res.users.noHandphone?.trim() === "") {
                    this.FormValuesEdit.userId = res.users.id
                    this.FormValuesEdit.email = res.users.email
                    this.FormValuesEdit.kontraktorId = res.users.kontraktorId

                    let button = document.createElement("a")
                    button.setAttribute("id", "updateNoHandphone")
                    button.setAttribute("data-bs-toggle", "modal")
                    button.setAttribute("data-bs-target", "#update-no-handphone")
                    document.body.appendChild(button)
                    document.querySelector("#updateNoHandphone").click()
                    button.remove()
                }
            } catch (e) {
                this.isLoading = false
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Terjadi kesalahan saat mencari detail User!",
                })
            }
        },
        async submitUpdateNoHandphone() {
            try {
                this.isNoHpValid = null
                let bodyJson = {
                    userId: this.FormValuesEdit.userId,
                    email: this.FormValuesEdit.email,
                    noHandphone: this.FormValuesEdit.noHandphone,
                    kontraktorId: this.FormValuesEdit.kontraktorId,
                    status: 1,
                }
                const role = this.userData.kontraktorID != null ? "kontraktor" : "isafe"
                const user = localStorage.getItem("user_cms")
                const tokens = JSON.parse(user)

                axios
                    .put(API_BASE_URL + CMS_GET_USER_UPDATE, bodyJson, {
                        headers: {
                            role: role,
                            Authorization: `Bearer ${tokens.token}`,
                            Accept: "application/json",
                            "Access-Control-Allow-Origin": "*",
                            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE",
                            "Access-Control-Allow-Headers": "Content-Type, Authorization, Accept",
                        },
                    })
                    .then(() => {
                        (this.FormValuesEdit = {
                            userId: "",
                            email: "",
                            kontraktorId: null,
                            noHandphone: "",
                        }),
                            document.getElementById("btnClose-update-no-handphone").click()

                        Swal.fire({
                            icon: "success",
                            title: "Data berhasil diupdate!",
                            showConfirmButton: false,
                            timer: 1000,
                        })
                    })
            } catch (e) {
                this.isLoading = false
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Terjadi kesalahan saat update data!",
                })
            }
        },
        validatePhoneEdit() {
            const phoneRegex = /^(?:62)[8][1-9][0-9]{6,11}$/ // Adjust pattern to fit rules
            if (this.FormValuesEdit.noHandphone.trim() === "") {
                this.isNoHpValid = null
            } else {
                this.isNoHpValid = phoneRegex.test(this.FormValuesEdit.noHandphone)
            }
        },
    },
}
</script>

<style scoped>
@import url("./../../assets/css/tailwind.css");

section {
    font-family: "Inter", sans-serif;
    font-style: normal;
    min-height: 100vh;
}

.background {
    background: linear-gradient(39.67deg, #000000 1.43%, rgba(0, 0, 0, 0) 74.24%),
        url("../../assets/images/tentang_bib.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    height: 289px;
}

.scrollable-container {
    height: 200px;
    /* Set a height for your container */
    overflow: auto;
    /* Make the container scrollable */
}
</style>
